import React, { useState } from 'react';
import {
  Row,
  Col,
  Button,
  Card,
} from 'react-bootstrap';
import PeopleLayout from '../layout/PeopleLayout';

import MarkdownRenderer from '../../common/components/MarkdownRenderer';

function RolePage(props) {
  return <PeopleLayout {...props} content={<RoleShow {...props} />} />;
}

function RoleShow({ progression, intro }) {
  const [level, setLevel] = useState();

  const changeLevel = (event) => {
    event.preventDefault();
    setLevel(parseInt(event.target.value, 10));
  };

  const topics = {};

  if (progression.content[level]) {
    topics.impact = {
      title: '💥 Impact',
      criteria: progression.content[level].impact,
    };

    topics.knowledge = {
      title: '🎓 Knowledge',
      criteria: progression.content[level].knowledge,
    };

    topics.behaviours = {
      title: '✨ Behaviours',
      criteria: progression.content[level].behaviours,
    };
  }

  let topicIntro = <IntroShow intro={intro} />;
  let content;

  if (level) {
    topicIntro = null;

    if (progression.content[level].intro) {
      topicIntro = <IntroShow intro={progression.content[level].intro} />;
    }

    content = (
      <>
        <TopicShow topic={topics.impact} size={12} />
        <TopicShow topic={topics.knowledge} size={6} />
        <TopicShow topic={topics.behaviours} size={6} />
      </>
    );
  }

  return (
    <>
      <Row className="mb-4">
        <Col md={12} style={{ display: 'flex', fontSize: '2em' }} className="text-muted">
          <Button style={{ marginRight: 'auto' }} className="ml-1" variant={level == null ? 'secondary' : 'outline-secondary'} onClick={() => setLevel(null)}>Intro</Button>
          <div style={{ display: 'inline-block' }} className="mr-2">Levels</div>
          {[...Array(progression.levels).keys()].map((thisLevel) => <Button key={thisLevel} className="ml-1" variant={thisLevel + 1 === level ? 'secondary' : 'outline-secondary'} value={thisLevel + 1} onClick={changeLevel}>{thisLevel + 1}</Button>)}
        </Col>
      </Row>

      <Row>
        {topicIntro}
        {content}
      </Row>
    </>
  );
}

function IntroShow({ intro }) {
  return (
    <Col md={12}>
      <Card className="mb-4">
        <Card.Body>
          <MarkdownRenderer content={intro} />
        </Card.Body>
      </Card>
    </Col>
  );
}

function TopicShow({ topic, size }) {
  return (
    <Col md={size}>
      <Card className="mb-4">
        <Card.Header>{topic.title}</Card.Header>
        <Card.Body>
          <ul>
            {topic.criteria.map((criteria, idx) => <li key={idx} className="mb-2" style={{ fontSize: '1.2em' }}>{criteria}</li>)}
          </ul>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default RolePage;
